// extracted by mini-css-extract-plugin
export default {"componentWrapper":"AddToShoppingListButton_componentWrapper__FX+xu","shoppingListButton":"AddToShoppingListButton_shoppingListButton__q0lq-"};